import { render, staticRenderFns } from "./InputSuggest.vue?vue&type=template&id=ffbfd81a&scoped=true&"
import script from "./InputSuggest.vue?vue&type=script&lang=js&"
export * from "./InputSuggest.vue?vue&type=script&lang=js&"
import style0 from "./InputSuggest.vue?vue&type=style&index=0&id=ffbfd81a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbfd81a",
  null
  
)

export default component.exports